/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Pudo_TitleInputs */

const en_ticket_pudo_title = /** @type {(inputs: Ticket_Pudo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parts pickup (PUDO)`)
};

const ja_ticket_pudo_title = /** @type {(inputs: Ticket_Pudo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部品受け取り (PUDO)`)
};

const fr_ticket_pudo_title = /** @type {(inputs: Ticket_Pudo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrait des pièces (PUDO)`)
};

const de_ticket_pudo_title = /** @type {(inputs: Ticket_Pudo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teileabholung (PUDO)`)
};

/**
* | output |
* | --- |
* | "Parts pickup (PUDO)" |
*
* @param {Ticket_Pudo_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_pudo_title = /** @type {((inputs?: Ticket_Pudo_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Pudo_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_pudo_title(inputs)
	if (locale === "ja") return ja_ticket_pudo_title(inputs)
	if (locale === "fr") return fr_ticket_pudo_title(inputs)
	return de_ticket_pudo_title(inputs)
});